<template>
  <!-- 计划信息卡片 -->
  <div class="cartItem" @click.stop>
    <div class="imgBox" @click.stop="toDetail(data)">
      <img :src="data.imgSrc" alt="图片缺失" />
      <div v-if="isDeabled" class="outOfStock">无货</div>
    </div>
    <div class="orderIfnBox">
      <p class="planName">{{ data.productName }}</p>
      <div class="dealerNameBox" @click.stop="addShowNum(data)">
        <div class="dealerName ellipsis">{{ data.dealerName }}</div>
        <div v-if="data.carInf">{{ data.carInf }}</div>
      </div>
      <div v-if="isDeabled" class="resetDealer" @click.stop="addShowNum(data)">
        重新选择经销商
      </div>
      <div v-else @click.stop>
        <template v-if="data.payTypeFlag==3">
          <div>
            <span class="priceNum priceWeight priceWidth"> ¥{{ data.depositPrice || 0 }} </span>
            <span class="priceNum priceText" style="font-size:.34rem"> 意向金* </span>
          </div>
           <!-- <div>
            <span class="priceNum priceWidth"> ¥{{ data.price }} </span>
            <span class="priceNum priceText"> 厂商建议零售价* </span>
          </div> -->
        </template>
          <template v-if="data?._data.productType==1 && data?._data.loyaltyTypeFlag==2">
          <span class="priceNum priceWeight priceWidth"> ¥{{ data.price }} </span>
          <span class="priceNum priceText"> 厂商建议零售价* </span>
        </template>
        <template v-else>
          <span class="priceNum priceWeight priceWidth"> ¥{{ data.price }} </span>
          <span class="priceNum priceText"> 厂商建议零售价* </span>
        </template>
        <div>
          <van-stepper v-model="buyAmountNum" :max="buyAmountLimit" integer button-size="20" disable-input @change="changeNum" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, inject, nextTick, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { updateShoppingInf } from '@/api/shoppingCar'
import { setConfirmGoodsStore } from '@/util/shoppingCar/handle'
import { Toast } from 'vant'
import _ from 'lodash'
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, { emit }) {
    const router = useRouter()
    const store = useStore()
    let { data } = toRefs(props)
    console.log(data.value)
    let addShowNum = inject('addShowNum')
    let calculateTotalNum = inject('calculateTotalNum')
    const state = reactive({
      data: data.value,
      buyAmountNum: data.value.num
    })
    const changeNum = _.debounce(async v => {
      calculateTotalNum()
      if (v >= state.buyAmountLimit) {
        Toast({
          message: '该商品已达到最大购买数量',
          position: 'bottom'
        })
      }
      const { id, customerCarId, delStatusFlag, gsCode, productId, productType ,loyaltyTypeFlag} = state.data._data
      const param = Object.assign({ id, customerCarId, delStatusFlag, gsCode, productId, productType,loyaltyTypeFlag }, { productQuantity: v })
      emit('changeNum', v)
      try {
        const {baumuster, brand, finEnd, finStart, menuBaumuster,payTypeFlag,productNo, spec, productTypeFlag} =  state.data._data
        await updateShoppingInf({...param, baumuster, brand, finEnd, finStart, menuBaumuster,payTypeFlag,productNo, spec, productTypeFlag})
      } catch (e) {
        console.error(e.message || '数据修改失败')
        Toast({
          message: e.message || '数据修改失败',
          position: 'bottom'
        })
      }
    }, 200)
    const toDetail = data => {
      const { productType, productId, gsCode,loyaltyTypeFlag } = data._data
      let path = ''
      let query = {}
      if (productType == 1 && loyaltyTypeFlag==1) {
        // 设置数据到vuex
        setConfirmGoodsStore(store, Object.assign({}, data._data, { imgSrc: data.imgSrc }))
        // 计划跳往计划详情
        path = '/planDetail'
        query = { loyaltyId: productId, from: 'shoppingCarList', event: '查看致友计划详情' }
      }
      if (productType === 2) {
        // 计划跳往轮胎详情
        path = '/tyreDetail'
        query = { tyreId: productId, gsCode, event: '查看轮胎详情' }
      }
      if(productType == 1 && loyaltyTypeFlag==2){
          setConfirmGoodsStore(store, Object.assign({}, data._data, { imgSrc: data.imgSrc }))
        // 轮胎计划
       path = '/planDetail'
        query = { loyaltyId: productId, from: 'TirePackage', event: '查看轮胎包计划详情' }
      }
      nextTick(() => {
        path && router.push({ path, query })
      })
    }

    const buyAmountLimit = computed(() => {
      const { productType, buyAmountLimit, stockAmount = 0 } = state.data._data
      if (productType === 2) {
        return Math.min.apply(Math, [stockAmount, buyAmountLimit, 4])
      } else {
        return buyAmountLimit
      }
    })
    const isDeabled = computed(() => !state.data.hasProduct && state.data._data.productType === 2)
    return {
      ...toRefs(state),
      addShowNum,
      changeNum,
      toDetail,
      buyAmountLimit,
      isDeabled
    }
  }
}
</script>
<style lang="scss" scoped>
.imgBox,
.imgBox img {
  position: relative;
  display: inline-block;
  width: 99px;
  height: 74px;
  vertical-align: top;
}
.outOfStock {
  position: absolute;
  width: 99px;
  height: 74px;
  top: 0;
  left: 0;
  font-size: 16px;
  line-height: 74px;
  color: #fff;
  text-align: center;
  background-color: rgba($color: #000000, $alpha: 0.5);
}
.cartItem {
  display: inline-block;
  width: calc(100% - 20px);
  font-size: 12px;
  color: #999;
}
.orderIfnBox {
  display: inline-block;
  padding-left: 8px;
  width: calc(100% - 110px);
}
.planName {
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 4px;
  color: #333;
  font-weight: 600;
}
.dealerNameBox {
  padding: 5px;
  line-height: 16px;
  background-color: #f9f9f9;
  div + div {
    margin-top: 5px;
  }
}
.priceNum {
  color: #666666;
}
.priceNum + .priceNum {
  margin-left: 16px;
  color: #666666;
}
.priceWeight {
  font-weight: 600;
  color: #3088c5;
}
.priceWidth{
  width: 90px;
  display: inline-block;
}
.priceText{
  margin-left: 0px !important;
  width: 102px;
  display: inline-block;
  text-align: right;
}
.resetDealer {
  margin-top: 5px;
  height: 24px;
  font-size: 12px;
  line-height: 24px;
  color: #c30000;
  border: solid 0.5px #c30000;
  text-align: center;
}
</style>
